import React,{useState, useEffect}from 'react'
import { fs,storage } from '../firebase';
import {Typography, Box, Stack, Dialog } from '@mui/material'
import {InputField} from './product/Components/InputField'
import {ProductDropDown} from './product/Components/ProductDropDown'
import PrintSticker from './PrintSticker';
import StickerDividend from './StickerDividend';
import StickerIndianDesign from './StickerIndiandesign';
import StickerIndianDesignWithoutPrice from './StickerIndianDesignWithoutPrice';
import {FlatButton} from './commonComponents/FlatButton'
import { useParams, useNavigate  } from 'react-router-dom';
import './product/AddApparel.css';
import { postFabricData, postImageFabric, putEditFabric } from '../api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const Addfabric = (props) => {
  const history= useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const {productDetails1, isFabricEdited, onFabricSaved} = props
  const [imagesList,setImagesList]=useState([]);
  const [imageUrls, setImageUrls] = useState([]);
  const [idPrefix,setIdPrefix]=useState('IDC-FAB')
  const [uniqueRecordId,setUniqueRecordId]=useState('')
  const [fabricsup,setFabricsup]=useState('');
  const [materialcd,setMaterial]=useState('');
  const [count,setCount]=useState('');
  const [construction,setConstruction]=useState('');
  const [composition,setComposition]=useState('');
  const   [gsm,setGsm]=useState('');
  const [cuttable,setCutablle]=useState('');
  const [finish,setFinish]=useState('');
  const [weave,setWeave]=useState('');
  const [fabrictype,setFabrictype]=useState('');
  const [price,setPrice]=useState('');
  const [moq,setMoq]=useState('');
  const [leadtime,setLeadtime]=useState('');
  const [submitted,setSubmitted]=useState('');
  const [fpt,setFpt]=useState('');
  const [remarks,setRemarks]=useState('');
  const [selectedDropdownValue,setSelectedDropdownValue]=useState(0);
  const [image,setImage]=useState(null);
  const [stickersList,setStickersList]=useState([])
  const [imageError,setImageError]=useState('');
  const [successMsg,setSuccesMsg]=useState('');
  const [uploadError,setUploadError]=useState('');
  const [isRecordEdited,setIsRecordEdited]=useState(false);
  const [openPrintSticker,setOpenPrintSticker]=useState(false);
  const [fabricDbId, setFabricDbId] = useState('');
  const types=['image/jpeg','image/jpg','image/png','image/svg','image/pdf'];

  useEffect(()=>{
    if(productDetails1 !== null && productDetails1 !== undefined){
      const {fabric_id, fabricsup, materialcd, count, construction, composition, gsm, finish,
        cuttable, weave, price, remarks,fabrictype,moq,submitted,fpt,leadtime,uniqueRecordId,imageUrls}=productDetails1

        setIsRecordEdited(true)
        setFabricDbId(fabric_id || '')
        setUniqueRecordId(uniqueRecordId) 
        setFabricsup(fabricsup)
        setMaterial(materialcd)
        setCount(count)
        setConstruction(construction)
        setComposition(composition)
        setGsm(gsm)
        setFinish(finish)
        setCutablle(cuttable)
        setWeave(weave)
        setFabrictype(fabrictype)
        setPrice(price)
        setRemarks(remarks)
        setMoq(moq)
        setLeadtime(leadtime)
       setSubmitted(submitted)
       setFpt(fpt)
       setImageUrls(imageUrls)
    }
  },[productDetails1])

     useEffect(()=>{
   
       if(imageUrls.length > 0 && imagesList.length > 0 && imageUrls.length === imagesList.length){
       // handleAddProducts() removed because upload handles it now
       }
   

    }, [imageUrls])

      function generateCode() {
       const length = 10;
       const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
       let code = '';
      for (let i = 0; i < length; i++) {
      code += characters.charAt(Math.floor(Math.random() * characters.length));
     }
    
      return code;
    
    }
        useEffect(() => {
          
            if(productDetails1 !== null && productDetails1 !== undefined){
              if(isFabricEdited === true){  
                 const {uniqueRecordId}=productDetails1
                 setUniqueRecordId(uniqueRecordId)
              }
        }else{
          const newCode = generateCode();
          setUniqueRecordId(`${idPrefix}-${newCode}`);
      }
        
   }, []);
  

  const handleProductImg=(e)=>{
    const imageFiles = []
    let imageTypeStatus = false
    Object.entries(e.target.files).map(([key, value])=>{
      if(value&&types.includes(value.type)){
        imageFiles.push(value)
      }else{
        imageTypeStatus = true
      }
    })

    if(imageTypeStatus){
      setImagesList([]);
      setImageError('plz select valid type')
     return
    }
  
    if (imageFiles.length > 0){
      setImagesList(imageFiles)
    }
}
  const handleAddProducts=async()=>{
    try {
      const createdBy = Number(localStorage.getItem("user_id") || localStorage.getItem("userId")) || 11;
      console.log("Value assigned to created_by in fabricData:", createdBy);
      const baseFabricData = {
        record_group_id: uniqueRecordId,
        fabricsup,
        materialcd,
        count,
        construction,
        composition,
        gsm,
        cuttable,
        finish,
        weave,
        fabrictype,
        price,
        moq,
        leadtime,
        submitted,
        fpt,
        remarks,
      };
      
      if (isRecordEdited && fabricDbId) {
        const fabricData = {
          ...baseFabricData,
        };
        const response = await putEditFabric(fabricDbId, fabricData);
        return response?.fabric_id || response?.data?.fabric_id || response?.id || fabricDbId;
      }

      const fabricData = {
        ...baseFabricData,
        created_by: createdBy
      };

      const response = await postFabricData(fabricData);
      return response?.fabric_id || response?.data?.fabric_id || response?.id || uniqueRecordId;
    } catch (error) {
      console.error("Error saving fabric: ", error);
      throw error;
    }
  }
  
  
  // const getPrintStickersList =async()=>{
  //   const value=await fs.collection('StickersList').get();
    
  //   const productsArray=[];
  //   for(var snap of value.docs){
  //     var data=snap.data();
  //     setStickersList(data.Stickers)
  //   }
  // }
  // useEffect(()=>{
  //   getPrintStickersList();
  // },[])
  /**Handle  Stickers list */
// const handleStickersList = ()=>{
//   return stickersList.map((element)=>{
//     return element
//   })
// }

/**Handle Stickers change */
const handleStickersChange = (e)=>{
  setStickersList(e.target.value)
}

/**Handle fabric supplier change */
const handlesupplierChange = (e)=>{
  setFabricsup(e.target.value)
}
/**Handle fabric count change */
const handlecountChange = (e)=>{
  setCount(e.target.value)
}
/**Handle fabric materialcd change */
const handlematerialcdChange = (e)=>{
  setMaterial(e.target.value)
}
/**Handle fabric Construction change */
const handleConstructionChange = (e)=>{
  setConstruction(e.target.value)
}
/**Handle fabric Composition change */
const handleCompositionChange = (e)=>{
  setComposition(e.target.value)
}
/**Handle fabric Gsm change */
const handleGsmChange = (e)=>{
  setGsm(e.target.value)
}
/**Handle fabric Cuttable-width change */
const handleCuttablewidthChange = (e)=>{
  setCutablle(e.target.value)
}
/**Handle fabric Finish change */
const handleFinishChange = (e)=>{
  setFinish(e.target.value)
}

/**Handle fabric Weave change */
const handleWeaveChange = (e)=>{
  setWeave(e.target.value)
}

/**Handle fabric Fabric-Type change */
const handleFabricTypeChange = (e)=>{
  setFabrictype(e.target.value)
}
/**Handle fabric Price change */
const handlePriceChange = (e)=>{
  setPrice(e.target.value)
}
/**Handle fabric MOQ change */
const handleMOQChange = (e)=>{
  setMoq(e.target.value)
}
/**Handle fabric Available Meters change */
const handleLeadTimeChange = (e)=>{
  setLeadtime(e.target.value)
}
/**Handle fabric Submitted to change */
const handleSubmittedtoChange = (e)=>{
  setSubmitted(e.target.value)
}
/**Handle fabric Fpt to change */
const handleFptChange = (e)=>{
  setFpt(e.target.value)
}
/**Handle fabric Remarks to change */
const handleRemarksChange = (e)=>{
  setRemarks(e.target.value)
}
/**Upload images and fetch stored image url's */
const FabhandleUploadimagesToFireStore = async ()=>{
    if (fabricsup===''|| materialcd===''|| count===''|| construction===''|| composition===''|| gsm==='' || finish===''
      ||cuttable==='' || weave===''|| price===''|| remarks===''|| fabrictype===''|| moq===''|| submitted===''|| fpt===''|| leadtime==='') {
      toast.error('Please Insert the Missing Fields', { position: "top-center", autoClose: 3000 });
      return;
    }

    if(imagesList.length === 0 && !isRecordEdited){
      toast.warn('Please select an image before submitting.', { position: "top-center", autoClose: 3000 });
      return;
    }

    try {
      if(imagesList.length > 0){
        const fabricId = await handleAddProducts();
        const urls = await Promise.all(imagesList.map(async (image, index)=>{
          return await uploadImageAsPromise(image, index, fabricId);
        }));
        setImageUrls(urls);
        toast.success(isRecordEdited ? 'Data Updated successfully' : 'Fabric Data Added Successfully', { position: "top-right", autoClose: 3000 });
      } else if(isRecordEdited === true){
        await handleAddProducts();
        toast.success('Data Updated successfully', { position: "top-right", autoClose: 3000 });
      }
      
      // Reset form
      setFabricsup('');
      setMaterial('');
      setCount('');
      setConstruction('');
      setComposition('');
      setGsm('');
      setCutablle('');
      setFinish('');
      setWeave('');
      setFabrictype('');      
      setPrice('');
      setMoq('');
      setLeadtime('');
      setSubmitted('');
      setFpt('');
      setRemarks('');
      setImagesList([]);
      setImageUrls([]);
      setImageError('');
      setUploadError('');
      if (document.getElementById('file')) {
        document.getElementById('file').value = '';
      }
      
      if(!isRecordEdited) {
        const newCode = generateCode();
        setUniqueRecordId(`${idPrefix}-${newCode}`);
      }

      if (typeof onFabricSaved === 'function') {
        await onFabricSaved();
      }
    } catch (error) {
      toast.error('An error occurred while saving: ' + error.message, { position: "top-center", autoClose: 4000 });
    }
}
//Handle waiting to upload each file using promise
function uploadImageAsPromise (image, index, fabricId) {
  return new Promise(async function (resolve, reject) {
    try {
      const createdBy = Number(localStorage.getItem("user_id") || localStorage.getItem("userId")) || 11;
      console.log("Value assigned to created_by for fabric image upload:", createdBy);
      const formData = new FormData();
      if (fabricId) {
        formData.append('fabric_id', fabricId);
      }
      formData.append('images', image);
      formData.append('created_by', createdBy);
      
      const data = await postImageFabric(formData);
      const url = data.image_urls?.[0] || data.url || data.image_url || data.location || data.Location || data.s3Url || data.s3_url || data.path || data.key;
      resolve(url);
    } catch (error) {
      reject(error);
    }
  });
}
const handlePrintSticker = ()=>{
  if(selectedDropdownValue===0){
    toast.warn('Select Sticker', { position: "top-right", autoClose: 2000 });
  }
  else
   setDialogOpen(true)    
}
const handleDialogToClose = () => {
  setDialogOpen(false);
}

  return(
    <React.Fragment>
      <ToastContainer />
    
      <Dialog onClose={handleDialogToClose} open={dialogOpen} PaperProps={{
        sx:{
          width: '70%',
          height:'70%',
          maxWidth: '70%',
          overflowX: 'scroll',
          overflowY: 'scroll',
          scrollBehavior:'auto'
        }
      }}>
      {
        selectedDropdownValue === 1 
        ?<PrintSticker fabricSupplier= {fabricsup} materialCode= {materialcd}
      count= {count} construction= {construction}
      composition= {composition} GSM= {gsm}
      finish= {finish} cuttableWidth= {cuttable}
      weave= {weave} price= {price}
      remarks= {remarks}> </PrintSticker>

      :selectedDropdownValue ===  2
      ?<StickerDividend fabricSupplier= {fabricsup} materialCode= {materialcd}
      count= {count} construction= {construction}
      composition= {composition} GSM= {gsm}
      finish= {finish} cuttableWidth= {cuttable}
      weave= {weave} price= {price}
      remarks= {remarks}
      ></StickerDividend>
      :selectedDropdownValue === 3
        ?<StickerIndianDesign fabricSupplier= {fabricsup} materialCode= {materialcd}
        count= {count} construction= {construction}
        composition= {composition} GSM= {gsm}
        finish= {finish} cuttableWidth= {cuttable}
        weave= {weave} price= {price}
        remarks= {remarks}
        ></StickerIndianDesign>
        :selectedDropdownValue === 4
        ?<StickerIndianDesignWithoutPrice fabricSupplier= {fabricsup} materialCode= {materialcd}
        count= {count} construction= {construction}
        composition= {composition} GSM= {gsm}
        finish= {finish} cuttableWidth= {cuttable}
        weave= {weave} price= {price}
        remarks= {remarks}
        ></StickerIndianDesignWithoutPrice>
        : null
}
</Dialog>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', pt: 4, pb: 6 }}>
        <div className="back-icon" onClick={() => history(-1)}>
          &lt; Back
        </div>
        <Typography variant='h6' sx={{ color: 'GrayText', mb: 1, textAlign: 'center' }}>ADD FABRIC</Typography>
        <Typography variant='body2' sx={{ fontFamily: 'Inter', mb: 4, textAlign: 'center' }}>{uniqueRecordId}</Typography>
        
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4, width: 'fit-content' }}>
          <Stack spacing={5} direction="row">
            <InputField label={'Supplier'} value={fabricsup} handleChange={handlesupplierChange} />
            <InputField label={'T2 Material Code'} value={materialcd} handleChange={handlematerialcdChange} />
            <InputField label={'Count'} value={count} handleChange={handlecountChange} />
          </Stack>

          <Stack spacing={5} direction="row">
            <InputField label={'Construction'} value={construction} handleChange={handleConstructionChange} />
            <InputField label={'Composition'} value={composition} handleChange={handleCompositionChange} />
            <InputField label={'Gsm'} value={gsm} handleChange={handleGsmChange} />
          </Stack>

          <Stack spacing={5} direction="row">
            <InputField label={'Cuttable-width'} value={cuttable} handleChange={handleCuttablewidthChange} />
            <InputField label={'Finish'} value={finish} handleChange={handleFinishChange} />
            <InputField label={'Weave'} value={weave} handleChange={handleWeaveChange} />
          </Stack>

          <Stack spacing={5} direction="row">
            <InputField label={'Fabric-Type'} value={fabrictype} handleChange={handleFabricTypeChange} />
            <InputField label={'Price'} value={price} handleChange={handlePriceChange} />
            <InputField label={'MOQ'} value={moq} handleChange={handleMOQChange} />
          </Stack>

          <Stack spacing={5} direction="row">
            <InputField label={'Available Meters'} value={leadtime} handleChange={handleLeadTimeChange} />
            <InputField label={'Submitted to'} value={submitted} handleChange={handleSubmittedtoChange} />
            <InputField label={'FPT'} value={fpt} handleChange={handleFptChange} />
          </Stack>

          <Stack spacing={5} direction="row" alignItems="center">
            <InputField label={'Remarks'} value={remarks} handleChange={handleRemarksChange} />
            
            <input type='file' id='file' multiple onChange={handleProductImg} />

            <Box>
              <Typography variant='body2' sx={{fontFamily:'serif'}}>
                <select className='' id="selectBox" value={selectedDropdownValue} onChange={(e)=>setSelectedDropdownValue(Number(e.target.value))}>
                  <option value={0} >---Select---</option>
                  <option value={1} >H&M</option>
                  <option value={2} >DIVIDED</option>
                  <option value={3} >INDIAN DESIGN with Price</option>
                  <option value={4} >INDIAN DESIGN without Price</option>
                </select> 
                <button className='ml-3 ' onClick={handlePrintSticker}>Print</button>
              </Typography>
            </Box>
          </Stack> 

          <Box display="flex" justifyContent="center" alignItems="center" sx={{ paddingTop: 4, paddingBottom: 4 }}>
            <FlatButton label='SUBMIT' onClick={FabhandleUploadimagesToFireStore}/>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  ) 
}
export default Addfabric
